import { useEffect } from "react";
import { countryMedia } from "../data/countryMedia";

// Real photography used as a watermark: a large scrimmed photo inside the hero
// section plus an ultra-faint full-page layer (driven by the --nv-country CSS
// variable consumed by .nv-country-bg in App.js).
export const CountryWatermark = ({ codes = ["se"], page = true }) => {
  const list = Array.isArray(codes) ? codes.filter(Boolean) : [codes];
  const code = list[0] || "se";
  const m = countryMedia(code);

  useEffect(() => {
    if (!page) return undefined;
    const root = document.documentElement;
    root.style.setProperty("--nv-country", `url(${m.photo})`);
    return () => root.style.removeProperty("--nv-country");
  }, [m.photo, page]);

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden="true" data-testid={`country-watermark-${code}`}>
      <img
        src={m.photo}
        srcSet={`${m.small} 900w, ${m.photo} 1600w`}
        sizes="100vw"
        alt=""
        decoding="async"
        data-testid={`watermark-main-${code}`}
        className="nv-wm-photo absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#F4F6F8] via-[#F4F6F8]/92 to-[#F4F6F8]/15" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#F4F6F8]/80 via-[#F4F6F8]/10 to-[#F4F6F8]" />
      <span className="absolute bottom-4 right-5 hidden font-mono2 text-[10px] uppercase tracking-[0.22em] text-[#5E7280]/70 lg:block" data-testid={`watermark-caption-${code}`}>
        {m.place}
      </span>
    </div>
  );
};

export default CountryWatermark;
